function Header({ title, subtitle }: { title?: string; subtitle?: string }) {
  // Don't render header for Guidebook - just show reservation info
  if (title === 'Guidebook') {
    return null;
  }

  return (
    <header className="text-center mb-6">
      <h1 className="text-3xl font-extrabold text-gray-900">{title}</h1>
      {subtitle && <p className="text-lg text-gray-600 mt-2">{subtitle}</p>}
    </header>
  );
}

export default Header;
